// removed by extract-text-webpack-plugin
module.exports = {"voucher":"_3kftB6LKtAjaI4ah8G-7Pt","tabContent":"_3JuUj0BhLirsEFD5QJfESs","vSection":"_nzK3K5ukurxAOE4Ypmhy","lists":"_2TTMnQT5YEy-MkBdmBNOi4","PCard":"_3kcguVLRPrGkFsTdAj-p2d","nodata":"_1zj-Vy5Xjr6tHXf9qq5wCI","voucherItem":"_2O-axMH9w7h6vppX-YWFo6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/ManagePromotion/NewPromotion.scss
// module id = 456
// module chunks = 0